/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductPurchaseConfirmDownloadResponseDto } from '../../models/product-purchase-confirm-download-response-dto';

export interface ProductPurchaseControllerConfirmDownload$Params {
  purchaseId: string;
}

export function productPurchaseControllerConfirmDownload(http: HttpClient, rootUrl: string, params: ProductPurchaseControllerConfirmDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductPurchaseConfirmDownloadResponseDto>> {
  const rb = new RequestBuilder(rootUrl, productPurchaseControllerConfirmDownload.PATH, 'post');
  if (params) {
    rb.query('purchaseId', params.purchaseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductPurchaseConfirmDownloadResponseDto>;
    })
  );
}

productPurchaseControllerConfirmDownload.PATH = '/api/product-purchase/download';
